var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collect-container",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"collect-icon",attrs:{"src":_vm.sectionIcon}}),_c('bi-button',{attrs:{"label":"区间配置","type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }